import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10.9707 12.0547H9.02734L9.99902 8.81445L10.9707 12.0547Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14.4873 2C14.0191 2.80912 13.75 3.74794 13.75 4.75C13.75 7.78757 16.2124 10.25 19.25 10.25C20.2522 10.25 21.1908 9.98007 22 9.51172V22H2V2H14.4873ZM5.15234 18H7.24414L8.42773 14.0547H11.5703L12.7529 18H14.8438L11.2441 6H8.75586L5.15234 18ZM16 18H18V11H16V18Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20.5322 3.4668L23.5693 4.75L20.5322 6.03223L19.25 9.06934L17.9668 6.03223L14.9307 4.75L17.9668 3.4668L19.25 0.430664L20.5322 3.4668Z"}}]};

const Ai1Filled = Vue.extend<IconProps>({
  name: 'Ai1FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'ai-1-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Ai1Filled;
